<div class="file-attachment-section">
  <div class="file-upload-container" [ngClass]="{'has-error': hasError}" (click)="triggerFileInput(fileInput)">
    <div class="file-upload-icon">
      <i class="icon-upload"></i> 
    </div>
    <div class="file-upload-text">{{ 'common.fields.file-attachment.add-files' | translate }}</div>
    
    <div class="error-message" *ngIf="hasError">
      {{ 'common.fields.file-attachment.files-exceed-limit' | translate }}
    </div>
    
    <input
      #fileInput
      type="file"
      multiple
      (change)="onFileSelected($event)"
      [accept]="acceptedFileTypes"
    />
    <p class="file-limits">
      {{ 'common.fields.file-attachment.max-files' | translate: { count: maxFiles } }}
      <br>{{ 'common.fields.file-attachment.max-size' | translate: { size: maxFileSizeMB } }}
    </p>
  </div>

  <div class="attached-files-list" *ngIf="attachedFileObjects.length > 0">
    <div class="file-preview-grid">
      <div
        class="attached-file-item"
        *ngFor="let item of attachedFileObjects; let i = index"
      >
        <div class="file-preview">
          <img *ngIf="isImageFile(item.fileType) && item.previewUrl" [src]="item.previewUrl" class="file-preview-image" [alt]="item.file.name">
          <div *ngIf="!isImageFile(item.fileType)" class="file-icon-container" [ngClass]="{'pdf-file': isPdfFile(item.fileType), 'doc-file': isWordFile(item.fileType), 'excel-file': isExcelFile(item.fileType)}">
            <img *ngIf="isPdfFile(item.fileType)" src="assets/images/pdf-file.svg" alt="PDF File">
            <img *ngIf="isWordFile(item.fileType)" src="assets/images/word-file.svg" alt="Word File">
            <img *ngIf="isExcelFile(item.fileType)" src="assets/images/sheets-file.svg" alt="Excel File">
            <i *ngIf="!isPdfFile(item.fileType) && !isWordFile(item.fileType) && !isExcelFile(item.fileType)" [ngClass]="item.icon"></i>
          </div>
          <div class="validation-indicator" [ngClass]="{'valid': item.isValid, 'invalid': !item.isValid}">
            <i class="icon-check" *ngIf="item.isValid"></i>
            <i class="icon-alert" *ngIf="!item.isValid"></i>
          </div>
          <button class="delete-overlay" type="button" (click)="removeFile(i); $event.stopPropagation()">
            <i class="icon-close"></i>
          </button>
        </div>
        <div class="file-info">
          <div class="file-name" [title]="item.file.name">{{ item.file.name }}</div>
          <div class="file-size">({{ formatFileSize(item.file.size) }})</div>
        </div>
      </div>
    </div>
  </div>
</div> 